import styled, { css } from 'styled-components';

import { Text } from '../../../../components';
import { Hint as TextAreaHint } from '../../../../components/TextArea/TextArea.styles';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACE[12]};
  flex-wrap: wrap;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
  margin-top: ${SPACE[16]};
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[12]};
`;

export const ToggleLabel = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

/** One field with its notes and error; `$warn` turns its counter to the warning tone. */
export const FieldBlock = styled.div<{ $warn: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};

  ${(p) =>
    p.$warn &&
    css`
      ${TextAreaHint} {
        color: ${COLORS.warning};
      }
    `}
`;

export const Preview = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const PreviewTitle = styled(Text)`
  font-size: 13px;
  font-weight: 500;
  color: ${COLORS.heading};
`;

/** The server's llms.txt as plain text (a React text child: nothing in it is markup). */
export const PreviewText = styled.pre`
  margin: 0;
  max-height: 320px;
  overflow: auto;
  padding: ${SPACE[12]} ${SPACE[16]};
  border: 1px solid ${COLORS.panelBorder};
  border-radius: 12px;
  background: ${COLORS.surfaceInset};
  color: ${COLORS.textMuted};
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const HintText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.warning};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;
